/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserLoggedIn
 */
export interface UserLoggedIn {
  /**
   *
   * @type {boolean}
   * @memberof UserLoggedIn
   */
  loggedIn: boolean;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  loginUrl: string;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  logoutUrl: string;
  /**
   *
   * @type {number}
   * @memberof UserLoggedIn
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  organisation: string;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  organisationUrl: string;
  /**
   *
   * @type {string}
   * @memberof UserLoggedIn
   */
  kvk: string;
  /**
   *
   * @type {number}
   * @memberof UserLoggedIn
   */
  organisationCurrentRequestCount: number;
  /**
   *
   * @type {boolean}
   * @memberof UserLoggedIn
   */
  broCredentialsSet: boolean;
}

/**
 * Check if a given object implements the UserLoggedIn interface.
 */
export function instanceOfUserLoggedIn(value: object): value is UserLoggedIn {
  if (
    (!("loggedIn" in (value as Record<string, any>)) &&
      !("logged_in" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["loggedIn"] === undefined &&
      (value as Record<string, any>)["logged_in"] === undefined)
  )
    return false;
  if (
    (!("loginUrl" in (value as Record<string, any>)) &&
      !("login_url" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["loginUrl"] === undefined &&
      (value as Record<string, any>)["login_url"] === undefined)
  )
    return false;
  if (
    (!("logoutUrl" in (value as Record<string, any>)) &&
      !("logout_url" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["logoutUrl"] === undefined &&
      (value as Record<string, any>)["logout_url"] === undefined)
  )
    return false;
  if (
    (!("userId" in (value as Record<string, any>)) &&
      !("user_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["userId"] === undefined &&
      (value as Record<string, any>)["user_id"] === undefined)
  )
    return false;
  if (!("username" in value) || value["username"] === undefined) return false;
  if (
    (!("firstName" in (value as Record<string, any>)) &&
      !("first_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["firstName"] === undefined &&
      (value as Record<string, any>)["first_name"] === undefined)
  )
    return false;
  if (
    (!("lastName" in (value as Record<string, any>)) &&
      !("last_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lastName"] === undefined &&
      (value as Record<string, any>)["last_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("organisation" in value) || value["organisation"] === undefined) return false;
  if (
    (!("organisationUrl" in (value as Record<string, any>)) &&
      !("organisation_url" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["organisationUrl"] === undefined &&
      (value as Record<string, any>)["organisation_url"] === undefined)
  )
    return false;
  if (!("kvk" in value) || value["kvk"] === undefined) return false;
  if (
    (!("organisationCurrentRequestCount" in (value as Record<string, any>)) &&
      !("organisation_current_request_count" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["organisationCurrentRequestCount"] === undefined &&
      (value as Record<string, any>)["organisation_current_request_count"] === undefined)
  )
    return false;
  if (
    (!("broCredentialsSet" in (value as Record<string, any>)) &&
      !("bro_credentials_set" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broCredentialsSet"] === undefined &&
      (value as Record<string, any>)["bro_credentials_set"] === undefined)
  )
    return false;
  return true;
}

export function UserLoggedInFromJSON(json: any): UserLoggedIn {
  return UserLoggedInFromJSONTyped(json, false);
}

export function UserLoggedInFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLoggedIn {
  if (json == null) {
    return json;
  }
  return {
    loggedIn: json["logged_in"],
    loginUrl: json["login_url"],
    logoutUrl: json["logout_url"],
    userId: json["user_id"],
    username: json["username"],
    firstName: json["first_name"],
    lastName: json["last_name"],
    email: json["email"],
    organisation: json["organisation"],
    organisationUrl: json["organisation_url"],
    kvk: json["kvk"],
    organisationCurrentRequestCount: json["organisation_current_request_count"],
    broCredentialsSet: json["bro_credentials_set"],
  };
}

export function UserLoggedInToJSON(json: any): UserLoggedIn {
  return UserLoggedInToJSONTyped(json, false);
}

export function UserLoggedInToJSONTyped(
  value?: UserLoggedIn | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    logged_in: value["loggedIn"],
    login_url: value["loginUrl"],
    logout_url: value["logoutUrl"],
    user_id: value["userId"],
    username: value["username"],
    first_name: value["firstName"],
    last_name: value["lastName"],
    email: value["email"],
    organisation: value["organisation"],
    organisation_url: value["organisationUrl"],
    kvk: value["kvk"],
    organisation_current_request_count: value["organisationCurrentRequestCount"],
    bro_credentials_set: value["broCredentialsSet"],
  };
}
